import isDate from 'lodash/isDate';
import padStart from 'lodash/padStart';

export function getWeekStart(date) {
  return new Date(date.getFullYear(), date.getMonth(), (date.getDate() - date.getDay()) + 1, 0, 0, 0);
}

export function getWeekEnd(date) {
  return new Date(date.getFullYear(), date.getMonth(), (date.getDate() - date.getDay()) + 5, 23, 59, 59);
}

export function getOrdinalDate(dateObj) {
  return isDate(dateObj) ? `${dateObj.getFullYear()}-${dateObj.getMonth()+1}-${dateObj.getDate()}` : '';
}

export function formatDate(date) {
  const dateString = getOrdinalDate(date);
  let [year, month, day] = dateString.split('-'); // eslint-disable-line prefer-const
  // add leading 0 to month and day for ISO format
  month = padStart(month, 2, '0');
  day = padStart(day, 2, '0');
  return `${year}-${month}-${day}`;
}

function addDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 0, 0, 0);
}

export function getWeek(date) {
  const week = [formatDate(date)];
  for (let i = 0; i < 4; i += 1) {
    date = addDay(date);
    week.push(formatDate(date));
  }
  return week;
}
